import { formatRange, Popover, SwapIcon, type Mode, type MoneyRange } from '@trippath/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  /** What the trigger says: how it goes now, or that it is not decided. */
  label: string;
  /** The ways it could go, each at what it should cost. */
  ways: { mode: Mode; estimate: MoneyRange }[];
  /** How it goes now, if it is decided. */
  mode: Mode | null;
  onPick: (way: { mode: Mode; estimate: MoneyRange }) => void;
}

/** How a stop goes on to the next, picked from the ways that can go there, each priced. */
export function WayPick({ label, ways, mode, onPick }: Props) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      label={t('plan.howOn')}
      trigger={(props) => (
        <button
          {...props}
          type="button"
          className="icon-button icon-button-small"
          aria-label={label}
          title={label}
        >
          <SwapIcon />
        </button>
      )}
    >
      <ul className="way-pick" aria-label={t('plan.howOn')}>
        {ways.map((way) => (
          <li key={way.mode}>
            <button
              type="button"
              className="way-pick-option"
              aria-pressed={way.mode === mode}
              onClick={() => {
                setOpen(false);
                onPick(way);
              }}
            >
              <span className={`mode-mark mode-${way.mode}`} aria-hidden="true" />
              <span>{t(`mode.${way.mode}`)}</span>
              <span className="mono quiet">{formatRange(way.estimate, i18n.language)}</span>
            </button>
          </li>
        ))}
      </ul>
    </Popover>
  );
}
